import React, { useState, useEffect } from 'react';
import { Box, Zoom } from '@mui/material'; // Removi IconButton pois estamos usando Box clicável
import { Close as CloseIcon } from '@mui/icons-material';
import { SOCIAL } from '../utils/constants';

import WhatsAppLogo from '../assets/LOGO-FUNDOCINZA.png';

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  if (isClosed) return null;

  return (
    <Zoom in={isVisible}>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 20, md: 30 },
          right: { xs: 20, md: 30 },
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end', // Alinha o botão de fechar à direita do container
          cursor: 'pointer'
        }}
      >
        {/* Botão de Fechar (Aumentado para acompanhar o tamanho) */}
        <Box 
          onClick={(e) => {
            e.stopPropagation();
            setIsClosed(true);
          }}
          sx={{
            bgcolor: 'rgba(0,0,0,0.6)',
            color: 'white',
            borderRadius: '50%',
            // Tamanho aumentado de 24 para 40px
            width: 40, 
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1, 
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
            transition: 'background 0.2s',
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.9)',
            }
          }}
        >
          {/* Ícone aumentado também */}
          <CloseIcon sx={{ fontSize: 24 }} />
        </Box>

        {/* Imagem do Logo (Link) - TAMANHO DOBRADO */}
        <Box
          component="a"
          href={SOCIAL.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'block',
            transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            '&:hover': {
              transform: 'scale(1.05)', 
            }
          }}
        >
          <Box
            component="img"
            src={WhatsAppLogo}
            alt="Fale comigo no WhatsApp"
            sx={{
              // ANTES: xs: 60, md: 70
              // AGORA (Dobrado):
              width: { xs: 120, md: 140 }, 
              height: { xs: 120, md: 140 },
              borderRadius: '50%',
              boxShadow: '0 6px 16px rgba(0,0,0,0.4)',
            }}
          />
        </Box>
      </Box>
    </Zoom>
  );
};

export default FloatingWhatsApp;